export function checkIsEmoji(str: string) {
  const regex = /^(\p{Extended_Pictographic}|\u200D)+$/gu
  const result = regex.test(str)
  return result
}
